import { useState } from 'react';
import { faqs } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="text-center mb-12">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
          常见问题
        </h2>
        <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
          关于十八禁内容的常见疑问，这里为您一一解答
        </p>
      </div>
      <div className="max-w-3xl mx-auto space-y-3">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full flex items-center justify-between px-5 md:px-6 py-4 text-left cursor-pointer"
            >
              <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                {faq.question}
              </span>
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                <i
                  className={`ri-${
                    openIndex === index ? 'subtract' : 'add'
                  }-line text-lg text-foreground-500 transition-transform duration-200`}
                ></i>
              </div>
            </button>
            <div
              className={`transition-all duration-300 overflow-hidden ${
                openIndex === index ? 'max-h-96 pb-4' : 'max-h-0'
              }`}
            >
              <p className="px-5 md:px-6 text-sm text-foreground-600 leading-relaxed">
                {faq.answer}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}